import { render, staticRenderFns } from "./assemblyEdit.vue?vue&type=template&id=da50c930"
import script from "./assemblyEdit.vue?vue&type=script&lang=js"
export * from "./assemblyEdit.vue?vue&type=script&lang=js"
import style0 from "./assemblyEdit.vue?vue&type=style&index=0&id=da50c930&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports